import { Component, OnInit } from '@angular/core';
import { mergeMap, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Checklist } from '../../../classes/checklist';
import { ChecklistCategory } from "../../../classes/checklistCategory";
import { ChecklistSubCategory } from "../../../classes/checklistSubCategory";
import { ChecklistService } from '../../../services/checklist';
import { ChecklistCategoryService } from "../../../services/checklistCategory";
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import {ChecklistSubCategoryService} from "../../../services/checklistSubCategory";

@Component({
  selector: 'app-checklist-update',
  templateUrl: './checklist-subcategory-update.component.html',
  styleUrls: ['./checklist-subcategory-update.component.css']
})
export class ChecklistSubcategoryUpdateComponent implements OnInit {
  checklist!: Checklist;
  checklistCategory!: ChecklistCategory;
  checklistSubCategory!: ChecklistSubCategory;
  checklistSubCategoryUpdateResult = true;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private checklistService: ChecklistService,
              private checklistCategoryService: ChecklistCategoryService,
              private checklistSubCategoryService: ChecklistSubCategoryService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
        this.checklistSubCategoryService.getByID(params.get('id'))
        .pipe(
            tap((checklistSubCategory: any) => {
                this.checklistSubCategory = checklistSubCategory;
            }),
            mergeMap(() => this.checklistCategoryService.getByID((this.checklistSubCategory.fk_id_checklist_category as number).toString())),
            tap((checklistCategory: any) => {
                this.checklistCategory = checklistCategory;
            }),
            mergeMap(() => this.checklistService.getByID((this.checklistCategory.fk_id_checklist as number).toString()))
        )
        .subscribe({
            next: (checklist: any) => {
                this.checklist = checklist;
            },
            error: (err: HttpErrorResponse) => {
                console.log(err);
            }
        });
    });
  }

  onSubmit() {
    this.checklistSubCategoryService.update(this.checklistSubCategory)
      .subscribe({
        next: () => {
          this.router.navigate(['/checklist-category/' + this.checklistCategory.id_checklist_category]);
        },
        error: (err: HttpErrorResponse) => {
          this.checklistSubCategoryUpdateResult = false;
          console.log(err);
        }
      });
  }

}
